import React from "react";
import moment from "moment";

import TodayEvents from "../elements/TodayEvents";
import EventList from "../elements/EventList";

import { getDateString } from "../utils";

class CalendarSummary extends React.Component {
  state = {
    today_date: {
      month: "",
      date: "",
      day: "",
    },
    upcoming_events: [],
    today_events: [],
    eventListStart: "",
    eventListEnd: "",
    loadEventList: false,
  };

  async loadUpcomingData() {
    this.setState({
      eventListStart: getDateString(moment().add(1, "days").toDate()),
      eventListEnd: getDateString(moment().add(2, "weeks").toDate()),
    });
  }

  async componentDidMount() {
    await this.loadUpcomingData();

    this.setState({
      loadEventList: true,
    });
  }

  render() {
    return (
      <div className="summaryContainer">
        <TodayEvents />
        {this.state.loadEventList && (
          <EventList
            startDate={this.state.eventListStart}
            endDate={this.state.eventListEnd}
          />
        )}
      </div>
    );
  }
}

export default CalendarSummary;

